import { render, staticRenderFns } from "./promo-section.vue?vue&type=template&id=62f4b840&scoped=true&"
import script from "./promo-section.vue?vue&type=script&lang=js&"
export * from "./promo-section.vue?vue&type=script&lang=js&"
import style0 from "./promo-section.vue?vue&type=style&index=0&id=62f4b840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4b840",
  null
  
)

export default component.exports